import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';


@Injectable({
  providedIn: 'root'
})
export class HhgAccessorialsService extends DataService {

  private baseURI = this.apiUri + '/hhgaccessorialsmaster/';

  constructor(http: HttpClient) {
    super(http);
  }

  getAll(): Observable<any> {
    this.setUri(this.baseURI);
    return this.get();
  }
}
